export var ControlMenuActionTypes;
(function (ControlMenuActionTypes) {
    ControlMenuActionTypes[ControlMenuActionTypes["AGGREGATE"] = 0] = "AGGREGATE";
    ControlMenuActionTypes[ControlMenuActionTypes["TIME_BUCKET"] = 1] = "TIME_BUCKET";
    ControlMenuActionTypes[ControlMenuActionTypes["FILTER"] = 2] = "FILTER";
    ControlMenuActionTypes[ControlMenuActionTypes["CONDITIONAL_FORMAT"] = 3] = "CONDITIONAL_FORMAT";
    ControlMenuActionTypes[ControlMenuActionTypes["SORT"] = 4] = "SORT";
    ControlMenuActionTypes[ControlMenuActionTypes["GROUP"] = 5] = "GROUP";
    ControlMenuActionTypes[ControlMenuActionTypes["POSITION"] = 6] = "POSITION";
    ControlMenuActionTypes[ControlMenuActionTypes["RENAME"] = 7] = "RENAME";
    ControlMenuActionTypes[ControlMenuActionTypes["EDIT"] = 8] = "EDIT";
    ControlMenuActionTypes[ControlMenuActionTypes["REMOVE"] = 9] = "REMOVE";
    ControlMenuActionTypes[ControlMenuActionTypes["SEPARATOR"] = 10] = "SEPARATOR";
    ControlMenuActionTypes[ControlMenuActionTypes["NUMBER_FORMAT"] = 11] = "NUMBER_FORMAT";
    ControlMenuActionTypes[ControlMenuActionTypes["TEXT_WRAPPING"] = 12] = "TEXT_WRAPPING";
})(ControlMenuActionTypes || (ControlMenuActionTypes = {}));
//# sourceMappingURL=types.js.map